module.exports = __webpack_public_path__ + "img/d1.c45ab6e0.png";